/**
 * vuex-typescript のヘルパーメソッドを定義するファイル。
 */
import { getStoreAccessors } from '../vuex-typescript'
import RootState from '../state'
import ComponentState from './state'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'

const { read, commit, dispatch } = getStoreAccessors<ComponentState, RootState>('manager')

export namespace Mutations {
  export const setInitialKajikiData = commit(mutations.setInitialKajikiData, 'setInitialKajikiData')
  export const setBaseData = commit(mutations.setBaseData, 'setBaseData')
  export const setArticlesData = commit(mutations.setArticlesData, 'setArticlesData')
  export const setCategoryData = commit(mutations.setCategoryData, 'setCategoryData')
  export const setModalState = commit(mutations.setModalState, 'setModalState')
  export const setUrlModalState = commit(mutations.setUrlModalState, 'setUrlModalState')
  export const updateContentSelection = commit(mutations.updateContentSelection, 'updateContentSelection')
  export const updateAllContentSelection = commit(mutations.updateAllContentSelection, 'updateAllContentSelection')
  export const setStorageData = commit(mutations.setStorageData, 'setStorageData')
  export const setLoadingKajiki = commit(mutations.setLoadingKajiki, 'setLoadingKajiki')
  export const setLoadingArticle = commit(mutations.setLoadingArticle, 'setLoadingArticle')
  export const setCategoryWholeData = commit(mutations.setCategoryWholeData, 'setCategoryWholeData')
}

export namespace Actions {
  export const loadArticles = dispatch(actions.loadArticles, 'loadArticles')
  export const loadKajikiData = dispatch(actions.loadKajikiData, 'loadKajikiData')
  export const copyContentItem = dispatch(actions.copyContentItem, 'copyContentItem')
  export const updateContentItem = dispatch(actions.updateContentItem, 'updateContentItem')
  export const deleteContentItem = dispatch(actions.deleteContentItem, 'deleteContentItem')
  export const selectedItemUpdate = dispatch(actions.selectedItemUpdate, 'selectedItemUpdate')
  export const selectedItemDelete = dispatch(actions.selectedItemDelete, 'selectedItemDelete')
  export const loadStorageData = dispatch(actions.loadStorageData, 'loadStorageData')
  export const loadCategories = dispatch(actions.loadCategories, 'loadCategories')
  export const loadCategoryWhole = dispatch(actions.loadCategoryWhole, 'loadCategoryWhole')
}

export namespace Getters {
  export const getActiveKajiki = read(getters.getActiveKajiki, 'getActiveKajiki')
  export const kajikiList = read(getters.kajikiList, 'kajikiList')
  export const getAcountData = read(getters.getAcountData, 'getAcountData')
  export const selectedArticles = read(getters.selectedArticles, 'selectedArticles')
  export const selectedArticleIds = read(getters.selectedArticleIds, 'selectedArticleIds')
  export const totalCount = read(getters.totalCount, 'totalCount')
  export const indexFrom = read(getters.indexFrom, 'indexFrom')
  export const isLoadingKajiki = read(getters.isLoadingArticle, 'isLoadingKajiki')
  export const isLoadingArticle = read(getters.isLoadingArticle, 'isLoadingArticle')
  export const totalStorage = read(getters.totalStorage, 'totalStorage')
  export const usedStorage = read(getters.usedStorage, 'usedStorage')
  export const accountName = read(getters.accountName, 'accountName')
}
